export const MERCURE_TOPIC = Object.freeze({
  ORDER_STATUS: 'preorder.order.payment-status',
  QR_STATUS: 'preorder.stockcard',
})

export default MERCURE_TOPIC
